import React, { useEffect, useState } from 'react'
import 'react-accessible-accordion/dist/fancy-example.css'
import AutoSuggestions from '../../Services/Queries/AutoSuggestions'
import GetPointsOfMovieOrPerson from '../../Services/Queries/GetPointsOfMovieOrPerson'
import AwsConfig from '../../Config/AwsConfig'
import GetAllTopMoviesWebseriesPersonsByPoints from '../../Services/Queries/GetAllTopMoviesWebseriesPersonsByPoints'
import PointsOverRideUi from './PointsOverRideUi'
import UpdatePointsForTrendingData from '../../Services/Mutations/UpdatePointsForTrendingData'
import { toast } from 'react-toastify'

function SearchPointsOverRide() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null)
  const [autoSuggestions, setAutoSuggestions] = useState([])
  const [searchBarVisible, setSearchBarVisible] = useState(false)
  const [selectedContentType, setselectedContentType] = useState('')
  const [Topmovies, setTopMovies] = useState([])
  const [TopPersons, setTopPersons] = useState([])
  const [TopWebserises, setTopWebseries] = useState([])
  const [AutoSuggestionSelectedOption, setAutoSuggestionSelectedOption] = useState('week')
  const [isLoading, setIsLoading] = useState(false)
  const [trendingTopMovies, setTrendingTopMovies] = useState([])
  const [trendingTopWebseries, setTrendingTopWebseries] = useState([])
  const [trendingTopPersons, setTrendingTopPersons] = useState([])
  const [trending, setTrending] = useState([])

  const toggleAccordion = (index, selectedContentType, Trending) => {
    setselectedContentType(selectedContentType ? selectedContentType : '')
    setOpenAccordionIndex(prevIndex => (prevIndex === index ? null : index))
    setAutoSuggestions([])
    setTrending(Trending ? Trending : 'manual')
    // setAutoSuggestionSelectedOption('')
  }

  const handleSubmitAllForms = async event => {
    event.preventDefault()
    // Logic to handle submission of all forms
    const newArrayTrendingMovies = trendingTopMovies.map(obj => ({
      contentType: 'movie',
      id: obj.movieID ? obj.movieID : obj.PK ? obj.PK : obj.id,
    }))
    const newArrayTrendingWebseries = trendingTopWebseries.map(obj => ({
      contentType: 'webseries',
      id: obj.movieID ? obj.movieID : obj.PK ? obj.PK : obj.id,
    }))
    const newArrayTrendingPersons = trendingTopPersons.map(obj => ({
      contentType: 'persons',
      id: obj.personID ? obj.personID : obj.PK ? obj.PK : obj.id,
    }))
    const input = {
      items: [...newArrayTrendingMovies, ...newArrayTrendingWebseries, ...newArrayTrendingPersons],
    }

    const updateResult = await UpdatePointsForTrendingData(input)
    // console.log(update, 'update=========')
    if (updateResult && updateResult.statusCode === '200') {
      toast.success('manual update sucessful!')
    } else {
      toast.error('Failed to update . Please try again.')
    }
  }

  const toggleSearchBar = () => {
    setSearchBarVisible(!searchBarVisible)
    setAutoSuggestions([])
    // setAutoSuggestionSelectedOption('')
  }

  const handleSelectAutoSuggestion = async suggestionIndex => {
    const selected = autoSuggestions[suggestionIndex]

    let { poster } = selected
    if (poster && !poster.includes(AwsConfig.movieCdnUrl)) {
      poster = AwsConfig.movieCdnUrl + poster
    }

    const input = {
      contentType: selectedContentType === 'person' ? 'persons' : selectedContentType,
      id: selected.PK,
      recordType: AutoSuggestionSelectedOption,
    }

    const getpoints = await GetPointsOfMovieOrPerson(input)

    const newItem = {
      contentType: selectedContentType === 'person' ? 'persons' : selectedContentType,
      id: selected.PK,
      recordType: AutoSuggestionSelectedOption,
      points: getpoints.points,
      poster,
      title_En:
        selectedContentType === 'movie' || selectedContentType === 'webseries'
          ? selected.title_En
          : selected.name_En,
    }

    switch (selectedContentType) {
      case 'movie':
        if (trending === 'Trending') {
          setTopMovies([...Topmovies, newItem])
        } else {
          setTrendingTopMovies([...trendingTopMovies, newItem])
        }

        break
      case 'webseries':
        if (trending === 'Trending') {
          setTopWebseries([...TopWebserises, newItem])
        } else {
          setTrendingTopWebseries([...trendingTopWebseries, newItem])
        }

        break
      default:
        if (trending === 'Trending') {
          setTopPersons([...TopPersons, newItem])
        } else {
          setTrendingTopPersons([...trendingTopPersons, newItem])
        }

        break
    }

    toggleSearchBar()
  }

  // const searchMoviePerson = async value => {
  //   if (value === '') {
  //     setAutoSuggestions([])
  //   }

  //   try {
  //     if (value.length >= 3) {
  //       const input = {
  //         search: value,
  //         type: selectedContentType,
  //         limit: 100,
  //         from: 0,
  //       }
  //       const searchedData = await AutoSuggestions(input)
  //       if (selectedContentType === 'movie' || selectedContentType === 'webseries') {
  //         const movieData = searchedData.movieHits ? searchedData.movieHits : []
  //         setAutoSuggestions(
  //           movieData
  //             ? movieData.map(movieItem => ({
  //                 ...movieItem,
  //                 label: movieItem.title_En,
  //                 poster: movieItem.posterURL,
  //               }))
  //             : [],
  //         )
  //       } else {
  //         const personData = searchedData.personHits ? searchedData.personHits : []
  //         setAutoSuggestions(
  //           personData
  //             ? personData.map(personItem => ({
  //                 ...personItem,
  //                 label: personItem.name_En,
  //                 poster: personItem.posterURL,
  //               }))
  //             : [],
  //         )
  //       }
  //     }
  //   } catch {
  //     setAutoSuggestions([])
  //   }
  // }
  const onRemove = id => {
    switch (selectedContentType) {
      case 'movie':
        if (trending === 'Trending') {
          const updatedTopMovies = Topmovies.filter(movie => movie.movieID !== id)
          setTopMovies(updatedTopMovies)
        } else {
          const updatedTrendingTopMovies = trendingTopMovies.filter(
            movie => !(movie.movieID === id || movie.id === id),
          )
          console.log(updatedTrendingTopMovies, 'updatedTrendingTopMovies======')
          setTrendingTopMovies(updatedTrendingTopMovies)
        }

        break
      case 'webseries':
        if (trending === 'Trending') {
          const updatedTopWebseries = TopWebserises.filter(webseries => webseries.movieID !== id)
          setTopWebseries(updatedTopWebseries)
        } else {
          const updatedTrendingTopWebseries = trendingTopWebseries.filter(
            webseries => !(webseries.movieID === id || webseries.id === id),
          )
          setTrendingTopWebseries(updatedTrendingTopWebseries)
        }

        break
      default:
        if (trending === 'Trending') {
          const updatedTopPersons = TopPersons.filter(person => person.personID !== id)
          setTopPersons(updatedTopPersons)
        } else {
          const updatedTrendingTopPersons = trendingTopPersons.filter(
            person => !(person.personID === id || person.id === id),
          )
          setTrendingTopPersons(updatedTrendingTopPersons)
        }

        break
    }
  }

  const searchMoviePerson = async value => {
    if (value === '') {
      setAutoSuggestions([])
      return
    }

    try {
      if (value.length >= 3) {
        const input = {
          search: value,
          type: selectedContentType,
          limit: 100,
          from: 0,
        }

        const searchedData = await AutoSuggestions(input)
        let suggestions = []

        if (selectedContentType === 'movie' || selectedContentType === 'webseries') {
          suggestions = searchedData.movieHits ? searchedData.movieHits : []
        } else {
          suggestions = searchedData.personHits ? searchedData.personHits : []
        }

        setAutoSuggestions(
          suggestions.map(item => ({
            ...item,
            label:
              selectedContentType === 'movie' || selectedContentType === 'webseries'
                ? item.title_En
                : item.name_En,
            poster: item.posterURL ? item.posterURL : '',
          })),
        )
      }
    } catch (error) {
      console.error('Error fetching auto suggestions:', error)
      setAutoSuggestions([])
    }
  }

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true)
      const input = {
        limit: 10,
        recordType: AutoSuggestionSelectedOption,
      }
      const data = await GetAllTopMoviesWebseriesPersonsByPoints(input)
      setTopMovies(data.topRecordsByPoints.trendingMovies || [])
      setTopWebseries(data.topRecordsByPoints.trendingWebseries || [])
      setTopPersons(data.topRecordsByPoints.trendingPersons || [])
      setTrendingTopMovies(data.manuallyUpdatedTrendingData.trendingMovies || [])
      setTrendingTopWebseries(data.manuallyUpdatedTrendingData.trendingWebseries || [])
      setTrendingTopPersons(data.manuallyUpdatedTrendingData.trendingPersons || [])
      setIsLoading(false)
    }

    getData()
  }, [AutoSuggestionSelectedOption])
  return (
    <PointsOverRideUi
      isLoading={isLoading}
      AutoSuggestionSelectedOption={AutoSuggestionSelectedOption}
      setAutoSuggestionSelectedOption={setAutoSuggestionSelectedOption}
      openAccordionIndex={openAccordionIndex}
      toggleAccordion={toggleAccordion}
      Topmovies={Topmovies}
      TopPersons={TopPersons}
      TopWebserises={TopWebserises}
      trendingTopMovies={trendingTopMovies}
      setTrendingTopMovies={setTrendingTopMovies}
      trendingTopPersons={trendingTopPersons}
      setTrendingTopPersons={setTrendingTopPersons}
      trendingTopWebseries={trendingTopWebseries}
      setTrendingTopWebseries={setTrendingTopWebseries}
      handleSubmitAllForms={handleSubmitAllForms}
      searchBarVisible={searchBarVisible}
      toggleSearchBar={toggleSearchBar}
      searchMoviePerson={searchMoviePerson}
      autoSuggestions={autoSuggestions}
      handleSelectAutoSuggestion={handleSelectAutoSuggestion}
      onRemove={onRemove}
      selectedContentType={selectedContentType}
    />
  )
}

export default SearchPointsOverRide
